// extracted by mini-css-extract-plugin
module.exports = {"bullets":"bullets-module--bullets--E1urs","bullet":"bullets-module--bullet--38v5K","activeBullet":"bullets-module--active-bullet--2ztu9"};